var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResearchingBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.09,271a191,191,0,0,0-10.37-48.66c-11.18-31.38-36.17-87.87-83-134-68.83-67.86-213.37-67.86-295-4.25S244,173.11,184,176.29,74.86,173.11,42.41,215.52-15.76,352.39,48.31,400s117.92,34.85,179,36,103.25,28.63,202.56,28.63S621.56,472.08,672.69,418C709.17,379.44,709.11,308.49,706.09,271Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.09,271a191,191,0,0,0-10.37-48.66c-11.18-31.38-36.17-87.87-83-134-68.83-67.86-213.37-67.86-295-4.25S244,173.11,184,176.29,74.86,173.11,42.41,215.52-15.76,352.39,48.31,400s117.92,34.85,179,36,103.25,28.63,202.56,28.63S621.56,472.08,672.69,418C709.17,379.44,709.11,308.49,706.09,271Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-246"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521,21.21V322h97.7V21.21Zm92.78,6.69V72.29H573.07V27.9ZM567,27.9V72.29H525.87V27.9ZM525.87,79.33H567v44.05H525.87Zm87.86,236H525.87V131h87.86ZM573.07,123.38v-44h40.66v44.05Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.27,21.21V322H716V21.21Zm92.79,6.69V72.29H670.39V27.9Zm-46.74,0V72.29H623.19V27.9ZM623.19,79.33h41.13v44.05H623.19Zm87.87,236H623.19V131h87.87ZM670.39,123.38v-44h40.67v44.05Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.86,
    y1: 180.95,
    x2: 567.33,
    y2: 211.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 597.95,
    y1: 173.37,
    x2: 594.05,
    y2: 178.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.66,
    y1: 233.74,
    x2: 535.64,
    y2: 239.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.24,
    y1: 195.46,
    x2: 544.42,
    y2: 229.32,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 690.7,
    y1: 190.27,
    x2: 666.17,
    y2: 220.8,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 696.79,
    y1: 182.69,
    x2: 692.89,
    y2: 187.55,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.5,
    y1: 243.06,
    x2: 634.48,
    y2: 248.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 672.08,
    y1: 204.78,
    x2: 643.26,
    y2: 238.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 702.03,
    y1: 34.87,
    x2: 690.29,
    y2: 49.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 704.94,
    y1: 31.25,
    x2: 703.07,
    y2: 33.57,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 677.52,
    y1: 60.14,
    x2: 675.12,
    y2: 62.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 693.11,
    y1: 41.82,
    x2: 679.32,
    y2: 58.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 656.21,
    y1: 34.87,
    x2: 644.47,
    y2: 49.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 659.12,
    y1: 31.25,
    x2: 657.26,
    y2: 33.57,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 631.7,
    y1: 60.14,
    x2: 629.3,
    y2: 62.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.3,
    y1: 41.82,
    x2: 633.5,
    y2: 58.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 656.21,
    y1: 89.62,
    x2: 644.47,
    y2: 104.23,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 659.12,
    y1: 85.99,
    x2: 657.26,
    y2: 88.32,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 631.7,
    y1: 114.89,
    x2: 629.3,
    y2: 117.72,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.3,
    y1: 96.57,
    x2: 633.5,
    y2: 112.78,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 697.07,
    y1: 89.62,
    x2: 685.33,
    y2: 104.23,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 699.99,
    y1: 85.99,
    x2: 698.12,
    y2: 88.32,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 672.57,
    y1: 114.89,
    x2: 670.16,
    y2: 117.72,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 688.16,
    y1: 96.57,
    x2: 674.37,
    y2: 112.78,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 605.44,
    y1: 34.87,
    x2: 593.7,
    y2: 49.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.35,
    y1: 31.25,
    x2: 606.49,
    y2: 33.57,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580.93,
    y1: 60.14,
    x2: 578.53,
    y2: 62.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.53,
    y1: 41.82,
    x2: 582.73,
    y2: 58.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 605.44,
    y1: 88.35,
    x2: 593.7,
    y2: 102.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.35,
    y1: 84.72,
    x2: 606.49,
    y2: 87.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580.93,
    y1: 113.62,
    x2: 578.53,
    y2: 116.44,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596.53,
    y1: 95.29,
    x2: 582.73,
    y2: 111.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.86,
    y1: 88.35,
    x2: 549.12,
    y2: 102.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.77,
    y1: 84.72,
    x2: 561.91,
    y2: 87.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.35,
    y1: 113.62,
    x2: 533.95,
    y2: 116.44,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.95,
    y1: 95.29,
    x2: 538.15,
    y2: 111.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.76,
    y1: 34.87,
    x2: 546.02,
    y2: 49.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.68,
    y1: 31.25,
    x2: 558.81,
    y2: 33.57,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 533.26,
    y1: 60.14,
    x2: 530.85,
    y2: 62.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548.85,
    y1: 41.82,
    x2: 535.06,
    y2: 58.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-246"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.04,
    y: 23,
    width: 166.96,
    height: 136.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.24,
    cy: 135.25,
    r: 10.72,
    transform: "translate(-38.87 75.06) rotate(-22.5)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.83,65.3a5.08,5.08,0,1,1-5.08-5.07A5.08,5.08,0,0,1,178.83,65.3Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.32,
    cy: 85.05,
    r: 3.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.91,
    cy: 130.17,
    r: 5.64,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,140.15l-5.86-3.22c-35.2-19.34-38.06-68.83-5.32-92.11l11.18-8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.46,159.5a145.23,145.23,0,0,1,3.65-85.09C156.94,52,165.84,35.3,174.22,23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.59,159.5c-2.68-20.25-3.06-57.37,17.13-102.21,6.6-14.68,12.93-25.82,18.77-34.29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,64.94C85,52.85,98.79,36.29,110.5,23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-246"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 98.76,
    y1: 386.64,
    x2: 98.76,
    y2: 283.81,
    style: {
      fill: "none",
      stroke: "#5e5e5e",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.97,
    y1: 388.71,
    x2: 85.97,
    y2: 246.7,
    style: {
      fill: "none",
      stroke: "#5e5e5e",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.98,
    y1: 389.41,
    x2: 114.98,
    y2: 339.53,
    style: {
      fill: "none",
      stroke: "#5e5e5e",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,260.7s-2.57-4.7-11.13-15S25.8,207.65,25.8,207.65s20.11,10.7,26.53,16.26,15,12.41,15,12.41-24-26.1-26.53-27.82S65.17,229,65.17,229,54.9,208.5,49.76,201.66s-15-23.11-15-23.11,27.81,37.23,29.09,39.37,6.85,11.55,6.85,11.55L60.89,203.8l12,21s-17.12-35.51-18-37.22,12,16.69,12,16.69L55.75,170.85l25.68,52.63-1.71-20.54,4.7,21.4,1.29-52.63,3,52.2s4.71-33.38,5.56-40.22,1.29-14.12,1.29-14.12-.86,45.35-.86,46.64-.86,11.55-.86,11.55L102,203.37c1.72-5.13,3.43-22.68,4.28-25.24s-4.28,39.36-4.7,41.07a49.73,49.73,0,0,1-3,8.13c-1.28,2.57,9.41-15.4,13.27-23.1L122.93,182s-6.42,21.39-8.13,25.24S102,231.61,102,231.61s16.69-19.68,24-24.82,20.54-15,20.54-15-21.39,23.1-25.67,27.38-16.69,19.25-16.69,19.25,21.4-13.69,22.68-15,16.69-11.12,16.69-11.12S112.41,236.89,111,238.45C98.54,251.72,94.26,258.14,91.7,260.7S84.85,264.55,81,260.7Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,298.21S94,294.88,87.9,287.62s-31.18-26.94-31.18-26.94,14.23,7.57,18.77,11.5S86.08,281,86.08,281s-17-18.46-18.76-19.67,17.25,14.53,17.25,14.53-7.27-14.53-10.9-19.37S63.08,240.1,63.08,240.1,82.75,266.43,83.66,268s4.84,8.17,4.84,8.17l-7-18.16L90,272.79S77.91,247.67,77.3,246.46s8.48,11.8,8.48,11.8l-7.87-23.6,18.16,37.22-1.21-14.53,3.33,15.14.9-37.23,2.12,36.92s3.33-23.6,3.94-28.44.91-10,.91-10-.61,32.08-.61,33-.61,8.17-.61,8.17l5.75-17.25c1.22-3.63,2.43-16,3-17.86s-3,27.84-3.33,29.06a34.4,34.4,0,0,1-2.12,5.75c-.9,1.81,6.66-10.9,9.39-16.35l7.86-15.73s-4.54,15.13-5.75,17.85-9.08,17.25-9.08,17.25,11.81-13.92,17-17.55,14.53-10.59,14.53-10.59-15.13,16.34-18.16,19.37-11.8,13.61-11.8,13.61,15.13-9.68,16-10.59S140,264,140,264s-22,17.36-23,18.46c-8.78,9.39-11.8,13.93-13.62,15.74A5,5,0,0,1,95.77,298.21Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.17,341.43s-1.82-3.33-7.87-10.6S72.13,303.9,72.13,303.9s14.22,7.56,18.76,11.5,10.59,8.78,10.59,8.78S84.54,305.71,82.72,304.5,100,319,100,319s-7.26-14.53-10.89-19.37-10.6-16.34-10.6-16.34,19.67,26.33,20.58,27.84,4.84,8.17,4.84,8.17l-7-18.16L105.42,316s-12.11-25.12-12.71-26.33,8.47,11.81,8.47,11.81l-7.87-23.61,18.16,37.23-1.21-14.53,3.33,15.13.91-37.22,2.12,36.92S120,291.79,120.55,287s.91-10,.91-10-.61,32.08-.61,33-.6,8.17-.6,8.17L126,300.87c1.21-3.63,2.42-16,3-17.85s-3,27.84-3.32,29.05a36.28,36.28,0,0,1-2.12,5.75c-.91,1.82,6.66-10.89,9.38-16.34s7.87-15.74,7.87-15.74-4.54,15.13-5.75,17.86S126,320.85,126,320.85s11.8-13.92,16.95-17.56,14.52-10.59,14.52-10.59S142.34,309,139.31,312.07s-11.8,13.62-11.8,13.62,15.13-9.69,16-10.59,11.8-7.87,11.8-7.87-22,17.35-23,18.46c-8.77,9.38-11.8,13.92-13.62,15.74A5,5,0,0,1,111.17,341.43Z",
    style: {
      fill: "#3C0E99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.32,422.69c0,20.2-5.31,38-13.43,48.81h-36c-8.11-10.77-13.43-28.61-13.43-48.81,0-1.77,0-3.52.12-5.24A107.75,107.75,0,0,1,69,404.4c.27-1.58.57-3.14.91-4.66.28-1.27.57-2.5.9-3.73A73.13,73.13,0,0,1,76.7,380.5h44.38A73.67,73.67,0,0,1,127,396c.33,1.23.63,2.46.91,3.73.33,1.52.63,3.08.9,4.66a107.75,107.75,0,0,1,1.39,13.05C130.28,419.17,130.32,420.92,130.32,422.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,396H70.77c-.33,1.23-.62,2.46-.9,3.73h58C127.63,398.47,127.33,397.24,127,396Zm1.81,8.39H69a107.75,107.75,0,0,0-1.39,13.05H130.2A107.75,107.75,0,0,0,128.81,404.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,377l4-8.67,9.33-4,8,1.34,4,3.33a8,8,0,0,1,.67,3.33c0,2-2,4.67-2,4.67a51,51,0,0,1-4,4.67c-2,2-2.67,2-4.67,3.33a9.55,9.55,0,0,1-4.66,1.33S149.33,384.33,148,377Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148 377 159.29 370.46 168.12 373.08 165.5 378.64 161.25 382.24 158.31 384.53 163.33 385",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "159.29 370.46 161.33 364.33 173.33 369 170.74 377.66 165.5 378.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "152.41 375.04 152.41 379.63 158.31 382.57 159.94 376.68 156.67 375.7 155.36 377.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65,353.48l9.31,2.1,5.86,8.29.37,8.1-2.42,4.61a8.17,8.17,0,0,1-3.12,1.35c-2,.42-5-1-5-1a50.73,50.73,0,0,1-5.4-2.94c-2.38-1.54-2.52-2.19-4.24-3.86a9.6,9.6,0,0,1-2.28-4.29S167.76,356.31,174.65,353.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "174.65 353.48 183.4 363.15 182.69 372.34 176.7 370.94 172.29 367.53 169.44 365.13 170.03 370.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "183.4 363.15 189.82 363.87 187.77 376.58 178.76 375.86 176.7 370.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "177.49 357.39 173.01 358.34 171.36 364.72 177.46 365.09 177.74 361.68 175.86 360.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.44,453.84l9.07-3,9.28,4.13,4.46,6.77.28,5.2a8.13,8.13,0,0,1-2,2.76c-1.46,1.36-4.78,1.7-4.78,1.7a50.36,50.36,0,0,1-6.14.24c-2.83-.11-3.28-.59-5.62-1.16a9.62,9.62,0,0,1-4.15-2.51S212,459.8,216.44,453.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "216.44 453.84 228.9 457.68 232.99 465.94 227.13 467.8 221.6 467.12 217.92 466.52 220.99 470.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "228.9 457.68 234.79 455.01 239.53 466.98 231.41 470.97 227.13 467.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "220.87 455.75 217.51 458.86 219.36 465.19 224.79 462.38 223.28 459.31 221.19 459.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,383.69l-9,3.14-9.36-3.94-4.59-6.69-.38-5.19a8.1,8.1,0,0,1,1.93-2.79c1.44-1.39,4.75-1.8,4.75-1.8a50.56,50.56,0,0,1,6.14-.37c2.83.05,3.29.53,5.64,1.05a9.58,9.58,0,0,1,4.2,2.43S213.44,377.63,209.09,383.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "209.09 383.69 196.54 380.1 192.29 371.93 198.12 369.95 203.66 370.51 207.35 371.04 204.2 367.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "196.54 380.1 190.71 382.89 185.74 371.01 193.77 366.86 198.12 369.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "204.61 381.87 207.91 378.69 205.94 372.4 200.56 375.31 202.13 378.35 204.22 378.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.86 373.2 144.19 373.2 151.46 471.29 209.59 471.29 216.86 373.2",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-246"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.38 294.39 287.03 294.39 288.54 269.25 289.63 251.05 327.77 251.05 328.87 269.25 330.38 294.39",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.87 269.25 288.54 269.25 289.63 251.05 327.77 251.05 328.87 269.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.76,
    y: 290.06,
    width: 65.89,
    height: 6.94,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1,138.33H386.3a9.1,9.1,0,0,1,9.1,9.1V252.78a7.8,7.8,0,0,1-7.8,7.8H229.8a7.8,7.8,0,0,1-7.8-7.8V147.44A9.1,9.1,0,0,1,231.1,138.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1,138.33H386.3a9.1,9.1,0,0,1,9.1,9.1v94.94a0,0,0,0,1,0,0H222a0,0,0,0,1,0,0V147.44A9.1,9.1,0,0,1,231.1,138.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.8,
    y: 147,
    width: 157.8,
    height: 86.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.33,
    y1: 199.67,
    x2: 255.33,
    y2: 199.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.33,
    y1: 203.67,
    x2: 255.33,
    y2: 203.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.33,
    y1: 207.67,
    x2: 255.33,
    y2: 207.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.33,
    y1: 211.67,
    x2: 255.33,
    y2: 211.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.81,
    y1: 179.08,
    x2: 235.87,
    y2: 160.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "280.09 212.03 260.15 179.08 295.7 167.81 280.09 212.03 342.52 209.43 365.93 161.74 300.03 167.81 339.05 204.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.52,
    y1: 209.43,
    x2: 377.2,
    y2: 224.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.15,179.08a4.34,4.34,0,1,1-4.34-4.33A4.34,4.34,0,0,1,260.15,179.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.85,209.43a4.34,4.34,0,1,1-4.33-4.34A4.34,4.34,0,0,1,346.85,209.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,167.81a4.34,4.34,0,1,1-4.33-4.33A4.33,4.33,0,0,1,300,167.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.26,161.74a4.34,4.34,0,1,1-4.33-4.33A4.33,4.33,0,0,1,370.26,161.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.43,212a4.34,4.34,0,1,1-4.34-4.33A4.34,4.34,0,0,1,284.43,212Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.24 143.94 226.84 156.9 241.01 156.9 241.41 144.75 227.24 143.94",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.57 152.61 384.17 165.56 398.34 165.56 398.75 153.42 384.57 152.61",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.09 171.07 214.69 184.03 228.86 184.03 229.26 171.88 215.09 171.07",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.12 187.67 216.71 200.63 230.88 200.63 231.29 188.48 217.12 187.67",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.08,274.28H154.33a11.25,11.25,0,0,0,0,22.5h67.75C215.66,284.13,222.08,274.28,222.08,274.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.17,274.28H185.42a11.25,11.25,0,1,0,0,22.5h67.75C246.74,284.13,253.17,274.28,253.17,274.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,298.28H185.42a12.75,12.75,0,1,1,0-25.5h69.72a1.5,1.5,0,0,1,0,3H185.42a9.75,9.75,0,1,0,0,19.5h69.72a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.14,
    y1: 276.06,
    x2: 182.14,
    y2: 294.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.14,
    y1: 282.13,
    x2: 196.5,
    y2: 282.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.79,
    y1: 285.77,
    x2: 197.11,
    y2: 285.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.55,
    y1: 289.61,
    x2: 204.39,
    y2: 289.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.64,247.47h67.75c6.22,0,11.25,5.7,11.25,12.72s-5,12.73-11.25,12.73H177.64C184.07,258.61,177.64,247.47,177.64,247.47Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.56,248.94h67.75a11.25,11.25,0,0,1,0,22.5H146.56C153,258.8,146.56,248.94,146.56,248.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.58,272.94h69.73a12.75,12.75,0,0,0,0-25.5H144.58a1.5,1.5,0,1,0,0,3h69.73a9.75,9.75,0,0,1,0,19.5H144.58a1.5,1.5,0,1,0,0,3Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.58,
    y1: 250.73,
    x2: 217.58,
    y2: 268.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.58,
    y1: 256.79,
    x2: 203.23,
    y2: 256.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.93,
    y1: 260.43,
    x2: 202.62,
    y2: 260.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.18,
    y1: 264.27,
    x2: 195.34,
    y2: 264.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.24,238c-3.85-1-8.09-3.23-15.78-3.23-6.65,0-10.27,3.33-11.12,4.22-.85-.89-4.47-4.22-11.12-4.22-7.68,0-11.93,2.22-15.77,3.23a103.48,103.48,0,0,1-10.52,1.82v8.7h74.82v-8.7A103,103,0,0,1,593.24,238Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.34,245.93a21.66,21.66,0,0,0-13.55-4.45A80,80,0,0,0,536,244.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568,244.31s3.44-3,11.73-2.22,20.42,3,20.42,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.42,240.27s1.62-.81,7.68,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.75,245.12s-.61-4.45-8.09-6.27a27.15,27.15,0,0,0-15.78,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.76,234c-9.1-1.42-17.39-12.14-27.09-9.1S566.34,239,566.34,239a15.1,15.1,0,0,1,15-7.86c10.71,1,14.76,7.28,24.06,7.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,249H536.25a11.25,11.25,0,0,0,0,22.5H604C597.58,258.85,604,249,604,249Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606,273H536.25a12.75,12.75,0,0,1,0-25.5H606a1.5,1.5,0,0,1,0,3H536.25a9.75,9.75,0,0,0,0,19.5H606a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.98,
    y1: 250.78,
    x2: 532.98,
    y2: 268.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.98,
    y1: 256.85,
    x2: 547.33,
    y2: 256.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.63,
    y1: 260.49,
    x2: 547.94,
    y2: 260.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 533.38,
    y1: 264.33,
    x2: 555.22,
    y2: 264.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.33,274.28H529.58a11.25,11.25,0,0,0,0,22.5h67.75C590.91,284.13,597.33,274.28,597.33,274.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.31,298.28H529.58a12.75,12.75,0,0,1,0-25.5h69.73a1.5,1.5,0,0,1,0,3H529.58a9.75,9.75,0,0,0,0,19.5h69.73a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.31,
    y1: 276.06,
    x2: 526.31,
    y2: 294.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.31,
    y1: 282.13,
    x2: 540.67,
    y2: 282.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 530.96,
    y1: 285.77,
    x2: 541.27,
    y2: 285.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.71,
    y1: 289.61,
    x2: 548.55,
    y2: 289.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-246"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "615 309.99 612.1 303.65 606.37 303.65 596.22 303.65 135.83 303.65 132 468 159 320 377 472 607 472 615 472 698 472 615 309.99",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "601.41 471.5 607 471.5 607 300.38 593 300.38 601.41 471.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.59 471.5 129 471.5 129 300.38 143 300.38 134.59 471.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.84,
    y: 303.76,
    width: 13.98,
    height: 5.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.59,
    y: 299.08,
    width: 97.7,
    height: 153.72,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.3,
    y: 303.65,
    width: 103.7,
    height: 8.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 297,
    width: 490,
    height: 8,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.4,
    y: 360.8,
    width: 84.02,
    height: 41.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.62,
    y: 378.52,
    width: 19.54,
    height: 5.91,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.4,
    y: 406.88,
    width: 84.02,
    height: 41.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.62,
    y: 424.61,
    width: 19.54,
    height: 5.91,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.23 356.26 538.17 379.06 606.58 379.06 606.58 331.21 594.62 319.25 520.23 356.26",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.4,
    y: 314.72,
    width: 84.02,
    height: 41.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.62,
    y: 332.44,
    width: 19.54,
    height: 5.91,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.82,449.25l24.86,16.64a2.77,2.77,0,0,1,1.36,2.38h0A2.76,2.76,0,0,1,464,471l-41.37-4.4a3.22,3.22,0,0,1-2.66-4.39l5.22-15.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,445l-26.76,21.11a2.79,2.79,0,0,0-1.36,2.39h0a2.77,2.77,0,0,0,3.06,2.75l41.37-4.4a3.24,3.24,0,0,0,2.67-4.39L329.5,445Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64,251.2s-3-8.66-4-11-8.65.67-8.65.67-4-2-5.66-1-3,4-3,4-4-1.33-5,1a20.7,20.7,0,0,0-1.33,4.66s-2.67,1-2.67,2.33-1.33,8,1.34,9,2.66-5.33,2.66-5.33,3.33,4.66,5.66,6.33,8.32,1.33,8.32,1.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,249.53a8.19,8.19,0,0,0-5.66.34c-2.66,1.33-11.32,13-12.65,15.64s-2,8-1,9.32,2.66-1,2.66-1,2-1.66,3.33-2.66a24.61,24.61,0,0,1,8.66-3.33c3.66-.66,11-12.65,11-12.65l-.66-2.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.07,242.88s25.63-14,28.63-15,13.65-4.33,18.64-4.33,7.65,0,8.32,1,8,5,9.65,6.32,4.33,4.66,2.33,5-5.32-1.34-6.32-1.34h-9c-1.66,0-8.32,2.33-11.65,3.67s-12,.33-12,.33l-18.64,22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5,313s-10.5,5-12,10.5S313,445,313,445h16.5l36-99.5S354,309.5,340.5,313Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.96,
    y1: 335.75,
    x2: 330,
    y2: 327.5,
    style: {
      fill: "none",
      stroke: "#8a8a8a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.29,299.46S335,331.75,335,335.75s9.32,12.64,14.32,14,109.18,7.65,109.18,7.65l-33.29,89.54a10.87,10.87,0,0,0,9.65,3.33l6-1S460.12,417,462.45,411s34.29-62.58,34.29-67.9-4.66-8.66-4.66-8.66l-70.57-20.3-4.33-2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.46,
    y1: 357.38,
    x2: 481,
    y2: 358,
    style: {
      fill: "none",
      stroke: "#8a8a8a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.56,184.29s-30.29-1.33-31.29,2S348,216.58,348,216.58s-19.64,38.94-25.64,46.27-4.32,17.31,5.33,19.64,17.31-4,17.31-4-6.32,19-4.66,22.3,33.29,11.66,50.26,13,26.63,1,29.3-1.33,6-28,8-31.29,7.66-26.63,7.66-26.63,24.63,31.29,31,31.62,32.95-18.64,32.95-18.64-4.33-10-8-14.32-9.32-4-9.32-4l-8.65,4.66s-15.32-23.63-17.65-28.29-.66-15.65-2.66-18-18-3-18-3l-47.27-21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.53,215.12c-8.38,6.3-23.74,19.23-27.17,31.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,211.2s-1.11.74-2.93,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.88,239.89a10,10,0,0,0-1.28,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.76,229.57a82.28,82.28,0,0,0-6,8.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.11,148s.33,7.65-1,11.32-5.33,6.65-5.33,8.32,6,12.31,4.66,13.31-9.65,2.33-9.65,2.33-8.66,13.65-10,14.32-16.64-5-16.64-5l-4,4L405.53,184l10.65-9.32s7.66-10,7-20.31-3-19.3,9.66-25.29,27-1.67,34.95,5.65S472.11,148,472.11,148Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.81,167h6l.33-9.32s11-.33,12.31-2-1.66-9,1.34-9.65,11.65,4.33,11.65,4.33,8.32-.67,7.32-13-19.64-20.31-34.62-20.31-27.29,9.32-28.62,18.64.33,21.64.66,28.63-7,12.32-3,14,20-4,22.64-7.32S441.81,167,441.81,167Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.15,168.31s-3-13-6-9-3,13.31-.66,16,4.33.67,4.33.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.48,
    y1: 163.65,
    x2: 472.11,
    y2: 168.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.74,175.92a9,9,0,0,0,.2-14.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.82,201.6s-10.31-12-17-16-20-8.65-24-7.32-8.32,6-8.32,6,15.31,6,28.29,12a130.37,130.37,0,0,0,23.3,8.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.52,
    y1: 198.31,
    x2: 359.6,
    y2: 191.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.95,
    y1: 278.49,
    x2: 357.55,
    y2: 204.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.94,
    y1: 239.88,
    x2: 348.28,
    y2: 219.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.43,
    y1: 235.12,
    x2: 343.29,
    y2: 231.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.61,
    y1: 244.54,
    x2: 347.55,
    y2: 238.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 449.57,
    y1: 237.84,
    x2: 453.46,
    y2: 233.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "440.48 236.55 435.49 254.53 446.38 241.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.74,
    y1: 244.92,
    x2: 459.79,
    y2: 243.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.49,
    y1: 254.53,
    x2: 453.25,
    y2: 246.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.76,268.51c-2.33-2.67-8.32-14.65-8.32-14.65l11.65,11.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.76,250.2s7.66,5,12,11.32,4.32,12.65,5,14.31a12.92,12.92,0,0,1,.66,4l12.32-8.65c3.33-2.33,4.66-2,3.66-5.33s-8.32-17.64-14.31-23-10.32-1.67-10.32-1.67l-11.32,8.32S475.1,249.87,478.76,250.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.2,
    y: 256.71,
    width: 100.62,
    height: 69.09,
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.38,
    y: 351.3,
    width: 91.34,
    height: 17.62,
    style: {
      fill: "#3C0E99",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.2,
    y: 256.71,
    width: 4.64,
    height: 214.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.72,
    y: 256.71,
    width: 4.64,
    height: 214.79,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-246"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 471.5,
    x2: 706,
    y2: 471.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchingBro);
export default __webpack_public_path__ + "static/media/Researching-bro.dffe35fbb43f583af61086a0b91ddb63.svg";
export { ForwardRef as ReactComponent };